export const setBookingCache = (payload) => ({ type: 'SET_BOOKING_CACHE', payload });

export const setInvoiceCache = (payload) => ({ type: 'SET_INVOICE_CACHE', payload });
